export default Object.freeze({
  ESTIMATE_AVAILABLE: 'ESTIMATE_AVAILABLE',
  TREATMENT_PENDING: 'TREATMENT_PENDING',
  TREATMENT_AVAILABLE: 'TREATMENT_AVAILABLE',
  DEPOSIT_PREPAYMENT: 'DEPOSIT_PREPAYMENT',
  DEPOSIT_INVOICE: 'DEPOSIT_INVOICE',
  ORDER_SHIPPED: 'ORDER_SHIPPED',
});
